<template>
  <!-- 多一个tips1的目的是为了解决同时显示两个tips时，会出现一个tips关闭不掉的问题 -->
  <!-- 外面包一层div是为了方便控制层级关系，最后用完也需要把它销毁 -->
  <div class="background_wraper"
       v-if="toastState.click">
    <!-- 绑定一个全屏点击背景 并加入淡入淡出效果 -->
    <!-- 不同类型提示的最外层 -->
    <div :class="[this.toastState.click ?  'click_tips1_background_active':'click_tips1_background', 
                  this.toastState.fade ? 'tips_fade_in':'fade_out_public' ]"
         @click.stop="backgroundClickHandle">
      <!-- 控制成功对号提示-白底 -->
      <div v-if="type === 1"
           class="tips1_baidi">
        <img src="~assets/img/tips/tips_baidi_chenggong.png"
             alt />
        <div class="tips1_baidi_text">{{objData}}</div>
      </div>
      <!-- 控制失败叉号提示-白底 -->
      <div v-else-if="type === 2"
           class="tips1_baidi">
        <img src="~assets/img/tips/tips_baidi_shibai.png"
             alt />
        <div class="tips1_baidi_text">{{objData}}</div>
      </div>
      <!-- 服务器错误消息提示   3    -->
      <div v-else-if="type === 3"
           class="tips1_baidi tips1_huidi">
        <img src="~assets/img/tips/tips1.png"
             alt />

        <div class="tips1_baidi_text">{{objData}}</div>
        <!-- <div class="tips1_baidi_text">设计了基于智能手机和GPRS网络的远程家电控制和安防监测系统</div> -->
      </div>

    </div>
  </div>
</template>

<script>
import store from 'store/index' ///导入公共仓库
import { objectClone } from 'common/tool'
import vm from '../../../main'
import {
  // deviceTypeJudge,
  // deviceTypeJudge1,
  publicDeviceTypeJudge ////设备类型判断
  // deviceStateFlip
} from 'components/content/contro-view/device-view/device-item-view-js'
export default {
  data () {
    return {}
  },
  components: {},
  methods: {
    backgroundClickHandle () {
      console.log('guanbi ')
      this.$closeTips1Toast() ///关闭toast控制弹窗
    }
  }
}
</script>

<style scoped>
/* .tips_wrap {
  position: fixed;
  top: 0%;
  bottom: 0%;
  left: 0%;
  right: 0%;
  z-index: 20;
} */
/* 激活时的背景 */

.click_tips1_background_active {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.3); */
  z-index: 21;
  cursor: pointer;
}

/* 不激活时的背景 */

.click_tips1_background {
  z-index: -1;
}

.tips1_baidi {
  width: 100px;
  height: 100px;
  background-color: #f5f5f5;
  border-radius: 5px;

  position: fixed;
  left: 50%;
  top: 46%;
  transform: translate(-50%, -50%);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* position: relative; */
  z-index: 25;

  /* //代号 20231116-1 */
  padding: 0 20px;
}

.tips1_baidi img {
  display: inline-block;
  height: 40px;
  width: 40px;
}
.tips1_baidi_text {
  align-content: center;
  font-size: 14px;
  display: inline-block;
}
.tips1_huidi {
  width: 250px;
  height: 150px;
  background-color: #f5f5f5;
  box-shadow: 1px 1px 5px 5px rgba(33, 33, 33, 0.1);

  color: #666666;

  box-sizing: border-box;
  padding: 20px;
  /* justify-content: flex-start; */
}
.tips1_huidi img {
  /* margin-top: 20px; */
  margin-bottom: 10px;
}
</style>














